import React from 'react';
import QucikBar from './quickbar';
import cur from '../../assets/PetIcon/cursor/character/default/normal.cur';
import press from '../../assets/PetIcon/cursor/character/default/press.cur';
import click from '../../assets/PetIcon/cursor/character/default/click.cur';
import Bubble from './bubble';
import cookie from 'react-cookies';
import '../../global';

class QQPet extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      translateX: 0,
      translateY: 0,
      QucikBar: false,
      Bubble: true,
      message: 'Hi,主人 我来也!!\n想我了吧?呵呵',
    };
    this.moving = false;
    this.click = false;
    this.lastX = null;
    this.lastY = null;
    this.barRef = React.createRef();
    this.myRef = React.createRef();
  }
  longPress = () => {
    this.click = false;
    this.moving = true;
    this.beforeDrop();
  };
  onMouseDown = e => {
    if (e.target === this.myRef.current) {
      this.click = true;
      this.lastX = e.clientX;
      this.lastY = e.clientY;
      global.pet.longpress = setTimeout(this.longPress, 200);
    }
  };
  animation(x, y) {
    clearTimeout(global.pet.timeout);
    let item;
    let player = document.querySelector('#container > ruffle-player');
    /*
      2.swf 看右下角    (146,168)->(170,180)
      3.swf 看左上角    ( 90, 90)->(110,110)
      4.swf 看左下角    ( 85,168)->(110,180)
      5.swf 看右上角    (140, 90)->(160,110)

      10.swf 亲嘴       (120,123)->(133,133)

      11.swf 伸出左手   ( 80,140)->( 86,160)
      12.swf 伸出右手   (160,140)->(168,161)
    */
    if (x >= 146 && x <= 170 && y >= 168 && y <= 180) {
      //监测右脚点击事件
      item = this.randomChoose(this.search('右脚'));
      player.load(item.blob);
      let time = (1000 * item.frame) / item.speed;
      global.pet.timeout = setTimeout(this.ReturnCommon, time);
      return;
    }
    if (x >= 85 && x <= 110 && y >= 168 && y <= 180) {
      //监测左脚点击事件
      item = this.randomChoose(this.search('左脚'));
      player.load(item.blob);
      let time = (1000 * item.frame) / item.speed;
      global.pet.timeout = setTimeout(this.ReturnCommon, time);
      return;
    }
    if (x >= 140 && x <= 160 && y >= 90 && y <= 110) {
      //监测右上方点击事件
      item = this.randomChoose(this.search('右上方'));
      player.load(item.blob);
      let time = (1000 * item.frame) / item.speed;
      global.pet.timeout = setTimeout(this.ReturnCommon, time);
      return;
    }
    if (x >= 90 && x <= 110 && y >= 90 && y <= 110) {
      //监测左上方点击事件
      item = this.randomChoose(this.search('左上方'));
      player.load(item.blob);
      let time = (1000 * item.frame) / item.speed;
      global.pet.timeout = setTimeout(this.ReturnCommon, time);
      return;
    }
    if (x >= 160 && x <= 168 && y >= 140 && y <= 161) {
      //监测右手点击事件
      item = this.randomChoose(this.search('右手'));
      player.load(item.blob);
      let time = (1000 * item.frame) / item.speed;
      global.pet.timeout = setTimeout(this.ReturnCommon, time);
      return;
    }
    if (x >= 80 && x <= 86 && y >= 140 && y <= 160) {
      //监测左手点击事件
      item = this.randomChoose(this.search('左手'));
      player.load(item.blob);
      let time = (1000 * item.frame) / item.speed;
      global.pet.timeout = setTimeout(this.ReturnCommon, time);
      return;
    }
    if (x >= 120 && x <= 133 && y >= 123 && y <= 133) {
      //监测嘴部点击事件
      item = this.randomChoose(this.search('嘴'));
      player.load(item.blob);
      let time = (1000 * item.frame) / item.speed;
      global.pet.timeout = setTimeout(this.ReturnCommon, time);
      return;
    }
    /*window.addEventListener('mousedown', this.onMouseDown);
    window.addEventListener('mousemove', this.onMouseMove);
    window.addEventListener('mouseup', this.onMouseUp);*/
  }
  onMouseUp = e => {
    clearTimeout(global.pet.longpress);
    if (this.click) {
      let x = e.offsetX; //获取Dom偏移量
      let y = e.offsetY;
      /*window.removeEventListener('mousedown', this.onMouseDown);
      window.removeEventListener('mousemove', this.onMouseMove);
      window.removeEventListener('mouseup', this.onMouseUp);*/
      this.animation(x, y);
    }
    if (this.moving) {
      this.Dropped();
    }
    this.moving = false;
    this.click = false;
    this.lastX = null;
    this.lastY = null;
  };
  onTouchDown = e => {
    if (e.target === this.myRef.current) {
      this.click = true;
      this.lastX = e.touches[0].clientX;
      this.lastY = e.touches[0].clientY;
      global.pet.longpress = setTimeout(this.longPress, 200);
    }
  };
  onTouchUp = e => {
    clearTimeout(global.pet.longpress);
    if (this.click) {
      let x = e.offsetX; //获取Dom偏移量
      let y = e.offsetY;
      this.animation(x, y);
    }
    if (this.moving) {
      this.Dropped();
    }
    this.moving = false;
    this.click = false;
    this.lastX = null;
    this.lastY = null;
  };
  onTouchMove = e => {
    e.preventDefault();
    if (this.moving) {
      if (this.lastX && this.lastY) {
        let dx = e.touches[0].clientX - this.lastX;
        let dy = e.touches[0].clientY - this.lastY;
        this.setState({
          translateX: this.state.translateX + dx,
          translateY: this.state.translateY + dy,
        });
        this.lastX = e.touches[0].clientX;
        this.lastY = e.touches[0].clientY;
      }
    }
  };
  onMouseMove = e => {
    if (this.moving) {
      if (this.lastX && this.lastY) {
        let dx = e.clientX - this.lastX;
        let dy = e.clientY - this.lastY;
        this.setState({
          translateX: this.state.translateX + dx,
          translateY: this.state.translateY + dy,
        });
        this.lastX = e.clientX;
        this.lastY = e.clientY;
      }
    }
  };
  beforeDrop = () => {
    clearTimeout(global.pet.timeout);
    let player = document.querySelector('#container > ruffle-player');
    let item = this.randomChoose(this.search('抓'));
    player.load(item.blob);
    let time = (1000 * item.frame) / item.speed;
    global.pet.timeout = setTimeout(this.drag, time);
  };
  drag = () => {
    clearTimeout(global.pet.timeout);
    let player = document.querySelector('#container > ruffle-player');
    let item = this.randomChoose(this.search('拖'));
    player.load(item.blob);
  };
  Dropped = () => {
    clearTimeout(global.pet.timeout);
    let player = document.querySelector('#container > ruffle-player');
    let item = this.randomChoose(this.search('放'));
    player.load(item.blob);
    let time = (1000 * item.frame) / item.speed;
    global.pet.timeout = setTimeout(this.ReturnCommon, time);
  };
  search = name => {
    let index = [];
    this.props.data.forEach(item => {
      if (item.name === name) index.push(item.id);
    });
    return index;
  };

  randomChoose = index => {
    if (index.length > 1)
      return this.props.data[index[Math.floor(index.length * Math.random())]];
    else return this.props.data[index[0]];
  };

  componentDidMount() {
    const grouth = parseInt(cookie.load('grouth'));
    const hungery = parseInt(cookie.load('hungery'));
    const clean = parseInt(cookie.load('clean'));
    const health = parseInt(cookie.load('health'));
    const mood = parseInt(cookie.load('mood'));
    const now = decodeURI(cookie.load('now'));
    let inFifteenMinutes = new Date(
      new Date().getTime() + 7 * 24 * 3600 * 1000,
    ); //一周
    if (
      !(
        Number.isFinite(grouth) &&
        Number.isFinite(hungery) &&
        Number.isFinite(clean) &&
        Number.isFinite(health) &&
        Number.isFinite(mood)
      )
    ) {
      //初始化宠物数值
      cookie.save('grouth', 5126, { path: '/', expires: inFifteenMinutes });
      cookie.save('hungery', 400, { path: '/', expires: inFifteenMinutes });
      cookie.save('clean', 510, { path: '/', expires: inFifteenMinutes });
      cookie.save('health', 600, { path: '/', expires: inFifteenMinutes });
      cookie.save('mood', 900, { path: '/', expires: inFifteenMinutes });
    } else {
      //更新存储周期
      cookie.save('grouth', grouth, { path: '/', expires: inFifteenMinutes });
      cookie.save('hungery', hungery, { path: '/', expires: inFifteenMinutes });
      cookie.save('clean', clean, { path: '/', expires: inFifteenMinutes });
      cookie.save('health', health, { path: '/', expires: inFifteenMinutes });
      cookie.save('mood', mood, { path: '/', expires: inFifteenMinutes });
    }
    if (now !== '成长中')
      cookie.save('now', '成长中', { path: '/', expires: inFifteenMinutes });
    global.pet.Interval1 = setInterval(() => {
      let inFifteenMinutes = new Date(
        new Date().getTime() + 7 * 24 * 3600 * 1000,
      ); //一周
      const hungery = parseInt(cookie.load('hungery'));
      const clean = parseInt(cookie.load('clean'));
      cookie.save('hungery', hungery - 2, {
        path: '/',
        expires: inFifteenMinutes,
      });
      cookie.save('clean', clean - 2, { path: '/', expires: inFifteenMinutes });
    }, 1000 * 60);
    global.pet.Interval2 = setInterval(() => {
      let inFifteenMinutes = new Date(
        new Date().getTime() + 7 * 24 * 3600 * 1000,
      ); //一周
      const grouth = parseInt(cookie.load('grouth'));
      cookie.save('grouth', grouth + 2, {
        path: '/',
        expires: inFifteenMinutes,
      });
    }, 1000 * 60 * 30);

    window.addEventListener('mousedown', this.onMouseDown);  //PC
    window.addEventListener('mousemove', this.onMouseMove);
    window.addEventListener('mouseup', this.onMouseUp);

    window.addEventListener('touchstart', this.onTouchDown);  //mobile
    window.addEventListener('touchmove', this.onTouchMove);
    window.addEventListener('touchend', this.onTouchUp);
    let data = this.props.data;
    function search(name) {
      let index = [];
      data.forEach(item => {
        if (item.name === name) index.push(item.id);
      });
      return index;
    }

    function randomChoose(index) {
      if (index.length > 1)
        return data[index[Math.floor(index.length * Math.random())]];
      else return data[index[0]];
    }

    window.RufflePlayer = window.RufflePlayer || {};
    window.RufflePlayer.config = {
      autoplay: 'on',
      unmuteOverlay: 'hidden',
      backgrounColor: null,
      wmode: 'transparent',
      contextMenu: false,
      preloader: false,
      quality: 'best',
      warnOnUnsupportedContent: false,
      // and so on...
    };
    let player;

    let ruffle = window.RufflePlayer.newest();
    player = ruffle.createPlayer();
    player.style.width = '250px';
    player.style.height = '200px';
    player.style.zIndex = -1;
    let container = document.getElementById('container');
    container.appendChild(player);

    let item = this.randomChoose(this.search('来')); //入场
    player.load(item.blob);
    let time = (1000 * item.frame) / item.speed;

    function ReturnCommon() {
      item = randomChoose(search('平常'));
      player.load(item.blob);
    }

    global.pet.timeout = setTimeout(ReturnCommon, time);
    setTimeout(() => {
      this.setState({ Bubble: false });
    }, time);
  }

  hover = e => {
    this.setState({ QucikBar: true });
    this.barRef.current.turnon();
    setTimeout(this.barRef.current.turnoff, 500);
  };

  ReturnCommon = () => {
    let player = document.querySelector('#container > ruffle-player');
    let item = this.randomChoose(this.search('平常'));
    player.load(item.blob);
    this.setState({ Bubble: false });
  };

  feed = () => {
    clearTimeout(global.pet.timeout);
    let player = document.querySelector('#container > ruffle-player');
    let item = this.randomChoose(this.search('喂食')); //喂食
    player.load(item.blob);
    let time = (1000 * item.frame) / item.speed;
    global.pet.timeout = setTimeout(this.ReturnCommon, time);
  };

  shower = () => {
    clearTimeout(global.pet.timeout);
    let player = document.querySelector('#container > ruffle-player');
    let item = this.randomChoose(this.search('清洁')); //喂食
    player.load(item.blob);
    let time = (1000 * item.frame) / item.speed;
    global.pet.timeout = setTimeout(this.ReturnCommon, time);
  };

  medicine = () => {
    clearTimeout(global.pet.timeout);
    let player = document.querySelector('#container > ruffle-player');
    let item = this.randomChoose(this.search('吃药')); //喂食
    player.load(item.blob);
    let time = (1000 * item.frame) / item.speed;
    global.pet.timeout = setTimeout(this.ReturnCommon, time);
  };

  work = () => {
    clearTimeout(global.pet.timeout);
    let player = document.querySelector('#container > ruffle-player');
    let item = this.randomChoose(this.search('工作')); //喂食
    player.load(item.blob);
    let time = (1000 * item.frame) / item.speed;
    global.pet.timeout = setTimeout(this.ReturnCommon, time);
  };

  study = () => {
    clearTimeout(global.pet.timeout);
    let player = document.querySelector('#container > ruffle-player');
    let item = this.randomChoose(this.search('学习')); //喂食
    player.load(item.blob);
    let time = (1000 * item.frame) / item.speed;
    global.pet.timeout = setTimeout(this.ReturnCommon, time);
  };

  showfeed = () => {
    this.barRef.current.feed();
  };

  showclean = () => {
    this.barRef.current.shower();
  };

  showmedicine = () => {
    this.barRef.current.medicine();
  };

  showstudy = () => {
    this.barRef.current.study();
  };

  showwork = () => {
    this.barRef.current.work();
  };

  BubbleLeave = () => {
    this.setState({ Bubble: true, message: '主人，再见！' });
  };
  BubbleOff = () => {
    this.setState({
      Bubble: false,
      message: 'Hi,主人 我来也!!\n想我了吧?呵呵',
    });
  };
  render() {
    return (
      <div>
        {this.state.Bubble ? (
          <Bubble
            x={this.state.translateX}
            y={this.state.translateY}
            close={this.BubbleOff}
            message={this.state.message}
          />
        ) : (
          <div
            style={{
              width: `226px`,
              height: `157px`,
              transform: `translate(calc(100vw - 360px + ${this.props.x}px),calc(100vh - 470px + ${this.props.y}px))`,
            }}
          ></div>
        )}
        <div>
          <QucikBar
            ref={this.barRef}
            x={this.state.translateX}
            y={this.state.translateY}
            hover={this.state.QucikBar}
            feed={this.feed}
            shower={this.shower}
            medicine={this.medicine}
            work={() => {
              this.props.work();
              this.work();
            }}
            study={() => {
              this.props.study();
              this.study();
            }}
            normal={this.props.normal}
          />
          <div
            ref={this.myRef}
            onMouseOver={this.hover}
            onMouseOut={() => this.setState({ QucikBar: false })}
            id="container"
            style={{
              width: '250px',
              height: '200px',
              cursor: `url(${
                this.click ? click : this.moving ? press : cur
              }), pointer`,
              transform: `translate(calc(100vw - 378px + ${this.state.translateX}px),calc(100vh - 500px + ${this.state.translateY}px))`,
            }}
          ></div>
        </div>
      </div>
    );
  }
}
export default QQPet;
